export enum RoutePath {
    AUTH = 'auth',
    SITES = 'sites',
    SITE = 'site',
    COMPANIES = 'companies',
    LOGIN = 'login',
    RESET_PASSWORD = 'reset-password',
}
